"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9146],{

/***/ 79146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ AboutHero_AboutHero; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./components/FormattedText/index.tsx
var FormattedText = __webpack_require__(89867);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
// EXTERNAL MODULE: ./components/TinaResponsiveAsset/index.ts + 3 modules
var TinaResponsiveAsset = __webpack_require__(77284);
;// CONCATENATED MODULE: ./blocks/AboutHero/AboutHero.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  width: 100%;\n  // 71px is height of navbar\n  height: calc(100vh - 71px);\n  position: relative;\n  // overflow: hidden;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 70%;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  text-align: center;\n  width: 80%;\n  margin: 0 auto;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2.5rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-position: center;\n  object-fit: contain;\n  position: absolute;\n  height: 100%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}






const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e621bd-0"
})(_templateObject(), ()=>(0,padding/* blockPadV */.zr)());
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e621bd-1"
})(_templateObject1(), ()=>(0,padding/* blockW */.g5)());
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e621bd-2"
})(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.mq.sm(_templateObject2());
}, (param)=>{
    let { theme  } = param;
    return theme.mq.lg(_templateObject3());
});
const SFormattedText = (0,styled_components_browser_esm/* default */.ZP)(FormattedText/* default */.Z).withConfig({
    componentId: "sc-2e621bd-3"
})(_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.mq.mdOnly(_templateObject5());
});
const StyledResponsiveAsset = (0,styled_components_browser_esm/* default */.ZP)(TinaResponsiveAsset/* default */.Z).withConfig({
    componentId: "sc-2e621bd-4"
})(_templateObject7());
const AboutHero = (param)=>{
    let { sublead , backgroundImg  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledResponsiveAsset, {
                    asset: backgroundImg
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SFormattedText, {
                        pFormat: "sansRegular52",
                        forwardedAs: "h1",
                        children: sublead
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AboutHero_AboutHero = (AboutHero);

;// CONCATENATED MODULE: ./blocks/AboutHero/index.ts



/***/ }),

/***/ 3185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GfxImage_GfxImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/GfxImage/GfxImage.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const GfxImage = (param)=>{
    let { layout , quality , src , width =0 , height =0 , objectFit , blurDataURL , placeholder ="empty" , alt , ...rest } = param;
    if (!src) {
        return null;
    }
    const isLayoutFill = layout === "fill";
    const isSvg = src.includes(".svg");
    const imageProps = {
        layout,
        ...rest,
        ...isSvg && {
            unoptimized: true
        },
        ...placeholder === "blur" && {
            blurDataURL: blurDataURL
        },
        ...objectFit !== "none" && {
            style: {
                objectFit
            }
        },
        ...!isLayoutFill && {
            width: width,
            height: height
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: src,
        placeholder: placeholder,
        alt: alt,
        quality: quality,
        ...imageProps
    });
};
/* harmony default export */ var GfxImage_GfxImage = ((0,styled_components_browser_esm/* default */.ZP)(GfxImage).withConfig({
    componentId: "sc-2250b3a7-0"
})(_templateObject()));

;// CONCATENATED MODULE: ./components/GfxImage/index.ts



/***/ }),

/***/ 54995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var components_GfxImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3185);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    max-height: 100vh;\n    flex: 0; \n    margin: 0 auto;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 0;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        border-radius: ",
        "px;\n      "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  padding: ",
        ";\n  ",
        "\n  ",
        "\n  /* desktop only need >= 0, cause if not we would simply take the border radius from mobile.\nMobile doesn't need it, since if you set mobile to 0, it reads as false and doesnt add border-radius */\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}




const Image = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(components_GfxImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-da1c7ae5-0"
})(_templateObject4(), (param)=>{
    let { $horizontalPaddingMobile  } = param;
    return $horizontalPaddingMobile && "0 1.5rem";
}, (param)=>{
    let { theme , $maxHeightMobile  } = param;
    return $maxHeightMobile && theme.mq.ltLg(_templateObject());
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject1());
}, (param)=>{
    let { theme: { mq  } , mobileborderradius , desktopborderradius  } = param;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject3(), "border-radius: ".concat(mobileborderradius ? mobileborderradius : 16, "px;"), mq.md(_templateObject2(), desktopborderradius ? desktopborderradius : 24));
});
const TinaAsset = (param)=>{
    let { asset , className , ...props } = param;
    // do not render anything if no URL is provided
    if (!asset || !(asset === null || asset === void 0 ? void 0 : asset.src)) {
        return null;
    }
    // We don't want to apply either attribute if both conditions are not met
    const imageBlur = (asset === null || asset === void 0 ? void 0 : asset.placeholder) === "blur" && (asset === null || asset === void 0 ? void 0 : asset.blurDataURL) && {
        placeholder: asset === null || asset === void 0 ? void 0 : asset.placeholder,
        blurDataURL: asset === null || asset === void 0 ? void 0 : asset.blurDataURL
    };
    const imageProps = {
        ...props,
        ...imageBlur
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
        ...imageProps,
        alt: (asset === null || asset === void 0 ? void 0 : asset.alt) || "image description",
        src: (asset === null || asset === void 0 ? void 0 : asset.src) || "",
        priority: Boolean(asset === null || asset === void 0 ? void 0 : asset.priority),
        quality: (asset === null || asset === void 0 ? void 0 : asset.quality) || 75,
        objectFit: (asset === null || asset === void 0 ? void 0 : asset.objectFit) || "none",
        className: className,
        $horizontalPaddingMobile: (asset === null || asset === void 0 ? void 0 : asset.horizontalPadding) ? true : undefined,
        $maxHeightMobile: (asset === null || asset === void 0 ? void 0 : asset.maxHeightMobile) ? asset === null || asset === void 0 ? void 0 : asset.maxHeightMobile : undefined,
        width: (asset === null || asset === void 0 ? void 0 : asset.width) || 0,
        height: (asset === null || asset === void 0 ? void 0 : asset.height) || 0
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(TinaAsset).withConfig({
    componentId: "sc-da1c7ae5-1"
})(_templateObject5()));


/***/ }),

/***/ 48642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _TinaAsset__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TinaAsset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54995);



/***/ }),

/***/ 77284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TinaResponsiveAsset_TinaResponsiveAsset; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/lodash/first.js
var first = __webpack_require__(8804);
var first_default = /*#__PURE__*/__webpack_require__.n(first);
// EXTERNAL MODULE: ./node_modules/lodash/takeRightWhile.js
var takeRightWhile = __webpack_require__(43464);
var takeRightWhile_default = /*#__PURE__*/__webpack_require__.n(takeRightWhile);
// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__(39693);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(48403);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
// EXTERNAL MODULE: ./components/TinaAsset/index.ts
var TinaAsset = __webpack_require__(48642);
// EXTERNAL MODULE: ./node_modules/lodash/set.js
var lodash_set = __webpack_require__(36968);
;// CONCATENATED MODULE: ./lib/tina/responsiveAssetConfig.ts

const responsiveAssetConfig_responsiveAssetConfig = (param)=>{
    let { label , name  } = param;
    return {
        label,
        name,
        description: "Image URL and metadata",
        type: "object",
        fields: [
            {
                type: "image",
                label: "Image Src",
                name: "src",
                ui: {
                    validate: (value, allValues, meta, field)=>{
                        if (value) {
                            const i = new Image();
                            const fieldRoot = field.name.replace(/\.src$/, "");
                            i.onload = ()=>{
                                set(allValues, "".concat(fieldRoot, ".width"), i.naturalWidth);
                                set(allValues, "".concat(fieldRoot, ".height"), i.naturalHeight);
                            };
                            i.src = value;
                        }
                    }
                }
            },
            {
                name: "width",
                label: "Width",
                type: "number",
                default: 0,
                ui: {
                    component: ()=>null
                }
            },
            {
                name: "height",
                label: "Height",
                type: "number",
                default: 0,
                ui: {
                    component: ()=>null
                }
            },
            {
                type: "boolean",
                label: "Priority",
                name: "priority"
            },
            {
                type: "string",
                label: "Alt Text",
                name: "alt"
            },
            {
                type: "number",
                label: "Quality",
                name: "quality"
            },
            {
                type: "string",
                label: "Blur effect (placeholder)",
                name: "placeholder",
                component: "select",
                options: [
                    {
                        value: "empty",
                        label: "empty"
                    },
                    {
                        value: "blur",
                        label: "blur"
                    }
                ]
            },
            {
                type: "string",
                label: "Blur base64",
                name: "blurDataURL",
                ui: {
                    component: "textarea"
                }
            },
            {
                type: "string",
                label: "Object Fit",
                name: "objectFit",
                component: "select",
                default: "none",
                options: [
                    {
                        value: "contain",
                        label: "contain"
                    },
                    {
                        value: "cover",
                        label: "cover"
                    },
                    {
                        value: "fill",
                        label: "fill"
                    },
                    {
                        value: "none",
                        label: "none"
                    }
                ]
            },
            {
                label: "Border Radius",
                name: "borderRadius",
                type: "number",
                description: "value in px"
            },
            {
                label: "Max height for mobile",
                name: "maxHeightMobile",
                type: "boolean",
                description: "Values are in vh"
            },
            {
                type: "boolean",
                label: "Horizontal padding",
                name: "horizontalPadding",
                description: "Only mobile if not in responsiveAsset. Default is false, if true it adds the same padding as on the text"
            }
        ]
    };
};
/* harmony default export */ var tina_responsiveAssetConfig = ((/* unused pure expression or super */ null && (responsiveAssetConfig_responsiveAssetConfig)));

;// CONCATENATED MODULE: ./lib/tina/responsiveAsset.ts

// this is the
const breakpointKeys = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
const responsiveAsset = (param)=>{
    let { label , name  } = param;
    const breakpointAssets = breakpointKeys.reduce((memo, key)=>{
        return [
            ...memo,
            responsiveAssetConfig({
                label: key,
                name: key
            })
        ];
    }, []);
    return {
        label,
        name,
        description: "Image URLs and metadata per breakpoint",
        type: "object",
        fields: breakpointAssets
    };
};
/* harmony default export */ var tina_responsiveAsset = ((/* unused pure expression or super */ null && (responsiveAsset)));

;// CONCATENATED MODULE: ./components/TinaResponsiveAsset/TinaResponsiveAsset.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-height: 100vh;\n    flex: 0;\n    margin: 0 auto;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  display: flex;\n  flex: 1;\n  ",
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  padding: 0;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}










const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35b26d8c-0"
})(_templateObject3(), (param)=>{
    let { $horizontalPadding  } = param;
    return $horizontalPadding ? "0 1.5rem" : "0";
}, (param)=>{
    let { theme , $maxHeightMobile  } = param;
    return $maxHeightMobile && theme.mq.ltLg(_templateObject());
}, (param)=>{
    let { max , theme  } = param;
    return max && theme.mq[max](_templateObject1());
}, (param)=>{
    let { min , theme  } = param;
    return min && min !== "xs" && theme.mq["lt".concat(capitalize_default()(min))](_templateObject2());
});
const BreakpointImage = (0,styled_components_browser_esm/* default */.ZP)(TinaAsset/* default */.Z).withConfig({
    componentId: "sc-35b26d8c-1"
})(_templateObject4(), (param)=>{
    let { $borderRadius  } = param;
    return $borderRadius && "".concat($borderRadius, "px");
});
function getNextBreakpoint(currentBp, props) {
    const definedKeys = breakpointKeys.filter((k)=>{
        return props === null || props === void 0 ? void 0 : props[k];
    });
    return first_default()(takeRightWhile_default()(compact_default()(definedKeys), (bp)=>bp !== currentBp));
}
const TinaResponsiveAsset = (param)=>{
    let { asset , className  } = param;
    if (isEmpty_default()(asset)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: breakpointKeys.filter((breakpoint)=>{
            return asset === null || asset === void 0 ? void 0 : asset[breakpoint];
        }).map((breakpoint)=>{
            const max = getNextBreakpoint(breakpoint, asset);
            const { borderRadius , maxHeightMobile , horizontalPadding , ...bpAsset } = (asset === null || asset === void 0 ? void 0 : asset[breakpoint]) || {};
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                $horizontalPadding: !!horizontalPadding,
                min: breakpoint,
                max: max,
                $maxHeightMobile: maxHeightMobile || undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakpointImage, {
                    asset: asset === null || asset === void 0 ? void 0 : asset[breakpoint],
                    className: className,
                    $borderRadius: borderRadius,
                    ...bpAsset
                })
            }, breakpoint);
        })
    });
};
/* harmony default export */ var TinaResponsiveAsset_TinaResponsiveAsset = ((0,styled_components_browser_esm/* default */.ZP)(TinaResponsiveAsset).withConfig({
    componentId: "sc-35b26d8c-2"
})(_templateObject5()));

;// CONCATENATED MODULE: ./components/TinaResponsiveAsset/index.ts



/***/ })

}]);